import * as apiMethods from "api/api";
import { SchemaConfiguration } from "api/factories/form.factory";
import { API, buildQueryParams, post, put } from "api/api";
import { OK } from "http-status-codes";

export interface SchemaReq {
    key: string;
    admaterial: number;
    matspec: number;
    language: string;
    internalUser?: boolean;
    timezone?: string;
}

export interface SchemaSubmitReq {
    // eslint-disable-next-line
    value: any;
    url: string;
}

export const getSchemaConfiguration = async (headers: HeadersInit, params: SchemaReq) => {
    const { parsedBody } = await apiMethods.get<SchemaConfiguration>(
        `${API.baseApiUrl}/customframe?${buildQueryParams(params)}`,
        {
            headers,
        }
    );

    return parsedBody;
};

export const postSchemaConfiguration = async (headers: HeadersInit, params: SchemaSubmitReq) => {
    if (params.value instanceof Date) {
        params.value = params.value.toISOString();
    }

    await post(params.url, null, { headers });

    return OK;
};

export const putSchemaConfiguration = async (headers: HeadersInit, params: SchemaSubmitReq) => {
    if (params.value instanceof Date) {
        params.value = params.value.toISOString();
    }

    await put(`${API.xServerUrl}${params.url}${params.value}`, null, { headers });

    return OK;
};

export const updateFormFieldsReq = async (
    headers: HeadersInit,
    fields: { [key: string]: string | number },
    materialSpecId: number,
    materialId?: number
) => {
    const queryParams = buildQueryParams({ matspec: materialSpecId, admaterial: materialId });
    await post(`${API.baseApiUrl}/dynamic-form?${queryParams}`, fields, { headers });

    return OK;
};
